import axios from 'axios'
import {AgentModel} from '../models/AgentModel'

const API_URL = process.env.REACT_APP_API_URL

// Get agents by page
export function getAgentsByPage(subscriberId: string, requestedPage: number) {
  return axios.get<AgentModel[]>(`${API_URL}/Subscribers/${subscriberId}/Agents`, {
    params: {
      'filter[limit]': 10,
      'filter[skip]': (requestedPage - 1) * 10,
      'filter[order]': 'created_on DESC',
    },
  })
}

// Create new agent
export function createAgent(
  subscriberId: string,
  data: {name: string; email: string; password: string}
) {
  return axios.post(`${API_URL}/Subscribers/${subscriberId}/Agents`, data)
}

// Update agent
export function updateAgent(subscriberId: string, agentId: string, data: any) {
  return axios.put(`${API_URL}/Subscribers/${subscriberId}/Agents/${agentId}`, data)
}

// Delete agent
export function deleteAgent(subscriberId: string, agentId: string) {
  return axios.delete(`${API_URL}/Subscribers/${subscriberId}/Agents/${agentId}`)
}
